import { render } from "./TSAControl.vue?vue&type=template&id=1b998524&scoped=true"
import script from "./TSAControl.vue?vue&type=script&lang=js"
export * from "./TSAControl.vue?vue&type=script&lang=js"

import "./TSAControl.vue?vue&type=style&index=0&id=1b998524&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b998524"]])

export default __exports__